module.exports = __webpack_public_path__ + "img/logo.a5f6f798.png";